// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PublicationSlots Styles */

.publication-slots-page {
    padding: 0;
}

.publication-slots-page .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
}

.publication-slots-page .page-header h1 {
    margin: 0;
}

.publication-slots-page .page-header-actions {
    display: flex;
    gap: 0.5rem;
}

/* Orphan-approved posts callout — shows above the slots grid when there are
   approved posts waiting for a publication slot. */
.orphan-callout {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    padding: 0.75rem 1rem;
    margin-bottom: 1.5rem;
    background: #fef3c7;
    border: 1px solid #f59e0b;
    border-radius: 8px;
    color: #78350f;
}

.orphan-callout-text {
    flex: 1 1;
    font-size: 0.95rem;
}

.orphan-callout .btn {
    flex-shrink: 0;
}

/* Slots Grid */
.slots-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 1rem;
}

.day-column {
    min-width: 0;
}

.day-column h3 {
    text-align: center;
    font-size: 0.9rem;
    margin-bottom: 0.75rem;
    color: #334155;
}

.day-slots {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.no-slots {
    text-align: center;
    color: #94a3b8;
    font-size: 0.8rem;
    padding: 1rem 0.5rem;
    border: 1px dashed #e2e8f0;
    border-radius: 8px;
}

.slot-card {
    position: relative;
    padding: 0.75rem;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.15s;
    border: 1px solid #e2e8f0;
}

.slot-card.active {
    background: #eff6ff;
    border-color: #93c5fd;
}

.slot-card.inactive {
    background: #f8fafc;
    border-color: #e2e8f0;
    opacity: 0.65;
}

.slot-card:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.slot-time {
    font-weight: 700;
    font-size: 1rem;
    color: #1e293b;
}

.slot-info {
    display: flex;
    justify-content: space-between;
    font-size: 0.75rem;
    color: #64748b;
    margin-top: 0.25rem;
}

.btn-delete {
    position: absolute;
    top: 4px;
    right: 6px;
    background: none;
    border: none;
    color: #94a3b8;
    font-size: 1.2rem;
    cursor: pointer;
    line-height: 1;
    padding: 2px 4px;
}

.btn-delete:hover {
    color: #ef4444;
}

/* Publication Slots Modal */
.ps-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.ps-modal {
    background: white;
    padding: 2rem;
    border-radius: 12px;
    width: 100%;
    max-width: 420px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
    position: relative;
    z-index: 10000;
}

.ps-modal h2 {
    margin: 0 0 1.5rem;
}

.ps-modal .form-group {
    margin-bottom: 1rem;
}

.ps-modal .form-group label {
    display: block;
    font-weight: 600;
    font-size: 0.85rem;
    margin-bottom: 0.25rem;
    color: #334155;
}

.ps-modal .form-group.checkbox label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
}

.ps-modal .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
}

.ps-modal select,
.ps-modal input[type='number'] {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-family: inherit;
    font-size: 0.9rem;
    box-sizing: border-box;
}

.ps-modal select:focus,
.ps-modal input[type='number']:focus {
    outline: none;
    border-color: #4f46e5;
    box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.15);
}

.ps-modal-actions {
    display: flex;
    gap: 0.75rem;
    justify-content: flex-end;
    margin-top: 1.5rem;
}

.ps-modal-actions button {
    padding: 0.5rem 1.25rem;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    font-size: 0.9rem;
}

.ps-modal-actions button:first-child {
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    color: #334155;
}

/* Responsive */
@media (max-width: 1024px) {
    .slots-grid {
        grid-template-columns: repeat(4, 1fr);
    }
}

@media (max-width: 640px) {
    .slots-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/PublicationSlots.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;mDACmD;AACnD;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,2CAA2C;IAC3C,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ","sourcesContent":["/* PublicationSlots Styles */\n\n.publication-slots-page {\n    padding: 0;\n}\n\n.publication-slots-page .page-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n}\n\n.publication-slots-page .page-header h1 {\n    margin: 0;\n}\n\n.publication-slots-page .page-header-actions {\n    display: flex;\n    gap: 0.5rem;\n}\n\n/* Orphan-approved posts callout — shows above the slots grid when there are\n   approved posts waiting for a publication slot. */\n.orphan-callout {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n    padding: 0.75rem 1rem;\n    margin-bottom: 1.5rem;\n    background: #fef3c7;\n    border: 1px solid #f59e0b;\n    border-radius: 8px;\n    color: #78350f;\n}\n\n.orphan-callout-text {\n    flex: 1;\n    font-size: 0.95rem;\n}\n\n.orphan-callout .btn {\n    flex-shrink: 0;\n}\n\n/* Slots Grid */\n.slots-grid {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    gap: 1rem;\n}\n\n.day-column {\n    min-width: 0;\n}\n\n.day-column h3 {\n    text-align: center;\n    font-size: 0.9rem;\n    margin-bottom: 0.75rem;\n    color: #334155;\n}\n\n.day-slots {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.no-slots {\n    text-align: center;\n    color: #94a3b8;\n    font-size: 0.8rem;\n    padding: 1rem 0.5rem;\n    border: 1px dashed #e2e8f0;\n    border-radius: 8px;\n}\n\n.slot-card {\n    position: relative;\n    padding: 0.75rem;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.15s;\n    border: 1px solid #e2e8f0;\n}\n\n.slot-card.active {\n    background: #eff6ff;\n    border-color: #93c5fd;\n}\n\n.slot-card.inactive {\n    background: #f8fafc;\n    border-color: #e2e8f0;\n    opacity: 0.65;\n}\n\n.slot-card:hover {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.slot-time {\n    font-weight: 700;\n    font-size: 1rem;\n    color: #1e293b;\n}\n\n.slot-info {\n    display: flex;\n    justify-content: space-between;\n    font-size: 0.75rem;\n    color: #64748b;\n    margin-top: 0.25rem;\n}\n\n.btn-delete {\n    position: absolute;\n    top: 4px;\n    right: 6px;\n    background: none;\n    border: none;\n    color: #94a3b8;\n    font-size: 1.2rem;\n    cursor: pointer;\n    line-height: 1;\n    padding: 2px 4px;\n}\n\n.btn-delete:hover {\n    color: #ef4444;\n}\n\n/* Publication Slots Modal */\n.ps-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.55);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n}\n\n.ps-modal {\n    background: white;\n    padding: 2rem;\n    border-radius: 12px;\n    width: 100%;\n    max-width: 420px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n    position: relative;\n    z-index: 10000;\n}\n\n.ps-modal h2 {\n    margin: 0 0 1.5rem;\n}\n\n.ps-modal .form-group {\n    margin-bottom: 1rem;\n}\n\n.ps-modal .form-group label {\n    display: block;\n    font-weight: 600;\n    font-size: 0.85rem;\n    margin-bottom: 0.25rem;\n    color: #334155;\n}\n\n.ps-modal .form-group.checkbox label {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n}\n\n.ps-modal .form-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n}\n\n.ps-modal select,\n.ps-modal input[type='number'] {\n    width: 100%;\n    padding: 0.5rem;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    font-family: inherit;\n    font-size: 0.9rem;\n    box-sizing: border-box;\n}\n\n.ps-modal select:focus,\n.ps-modal input[type='number']:focus {\n    outline: none;\n    border-color: #4f46e5;\n    box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.15);\n}\n\n.ps-modal-actions {\n    display: flex;\n    gap: 0.75rem;\n    justify-content: flex-end;\n    margin-top: 1.5rem;\n}\n\n.ps-modal-actions button {\n    padding: 0.5rem 1.25rem;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    font-size: 0.9rem;\n}\n\n.ps-modal-actions button:first-child {\n    background: #f1f5f9;\n    border: 1px solid #e2e8f0;\n    color: #334155;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n    .slots-grid {\n        grid-template-columns: repeat(4, 1fr);\n    }\n}\n\n@media (max-width: 640px) {\n    .slots-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
